exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1RSxExqtUfNmdKAE8HIzJ7{position:relative}\n", ""]);

// Exports
exports.locals = {
	"Tooltips": "_1RSxExqtUfNmdKAE8HIzJ7"
};